<template>
  <div class="tabnav" v-if="showTabnav">
    <h1>
      {{ $t('hs.att-dashboard.test-certificate') }} <br />
      {{ $t('hs.att-dashboard.microwave-components') }}
    </h1>
    <div v-if="availableInfoResponse && availableInfoResponse.prop">
      <button v-if="availableInfoResponse.prop(linkEntryPoints.infoService)" class="clavis-btn clavis-btn-secondary" v-bind:class="['tab-button', { active: currentTab === 'rl-il' }]" v-on:click="tabchange('rl-il')">{{ $t('hs.att-dashboard.rlil') }}</button>
      <button v-if="availableInfoResponse.prop(linkEntryPoints.pimInfoService)" class="clavis-btn clavis-btn-secondary" v-bind:class="['tab-button', { active: currentTab === 'pim' }]"  v-on:click="tabchange('pim')">{{ $t('hs.att-dashboard.pim') }}</button>
    </div>
  </div>
</template>

<script>
  import { createInfoServiceParams, getResponseFromEntryPoint, linkEntryPoints } from '@/rest/restClient'

  export default {
    name: 'Tabnav',
    data () {
      return {
        currentTab: 'rl-il',
        availableInfoResponse: null,
        linkEntryPoints: linkEntryPoints,
        showTabnav: false
      }
    },
    props: {
      articleNo: {
        type: String,
        required: true
      },
      serialNo: {
        type: String,
        required: true
      }
    },
    methods: {
      async fetchData () {
        const params = createInfoServiceParams(this.articleNo, this.serialNo)
        // let client = createClient(halConstants.BASE_PATH)
        const response = await getResponseFromEntryPoint(linkEntryPoints.availableInfoService, params)
        if (!response.error) {
          this.availableInfoResponse = response
        } else {
          this.availableInfoResponse = null
        }
      },
      tabchange (componentName) {
        this.currentTab = componentName
        this.$emit('tab-change', componentName)
      }
    },
    watch: {
      availableInfoResponse: {
        handler () {
          this.showTabnav = false
          if (this.availableInfoResponse && this.availableInfoResponse.prop) {
            if (this.availableInfoResponse.prop(linkEntryPoints.infoService)) {
              this.tabchange('rl-il')
              this.showTabnav = true
            } else if (this.availableInfoResponse.prop(linkEntryPoints.pimInfoService)) {
              this.tabchange('pim')
              this.showTabnav = true
            }
          }
        },
        deep: true
      }
    },
    created () {
      if (this.articleNo && this.serialNo) {
        this.fetchData()
      }
      this.$watch(vm => [vm.articleNo, vm.serialNo].join(), this.fetchData)
    }
  }
</script>

<style lang="scss" scoped>
.tabnav {
  padding-bottom: 2rem;

  .clavis-btn {
    margin: $button-margin;
    font-family: "Futura", sans-serif;
    font-weight: 300;
    font-size: 1.6rem;
    letter-spacing: 1px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &.active {
      font-weight: 700;
    }
  }
}
</style>
